import { type TFunction } from 'react-i18next';
import { boolean, object, string } from 'yup';

import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';

const MIN_FIELD_LENGTH = 2;
const MIN_ZIP_LENGTH = 5;
const BILLING_ERRORS_TEXT = TranslationEntries.Repairs.BillingDetails.Error;

export const billingDetailsFormSchema = (
  t?: TFunction<'translation', undefined>
) => {
  return object({
    billingIsSame: boolean(),
    city: string().when('billingIsSame', {
      is: false,
      otherwise: (schema) => schema.notRequired(),
      then: (schema) =>
        schema
          .required(
            t ? t(BILLING_ERRORS_TEXT.CityRequired) : 'City is required.'
          )
          .min(
            MIN_FIELD_LENGTH,
            t ? t(BILLING_ERRORS_TEXT.CityInvalid) : 'City should be longer.'
          ),
    }),
    firstName: string()
      .required(
        t ? t(BILLING_ERRORS_TEXT.FirstNameRequired) : 'First name is required'
      )
      .min(
        MIN_FIELD_LENGTH,
        t
          ? t(BILLING_ERRORS_TEXT.FirstNameInvalid)
          : 'First name should be longer.'
      ),
    lastName: string()
      .required(
        t ? t(BILLING_ERRORS_TEXT.LastNameRequired) : 'Last name is required.'
      )
      .min(
        MIN_FIELD_LENGTH,
        t
          ? t(BILLING_ERRORS_TEXT.LastNameInvalid)
          : 'Last name should be longer.'
      ),
    line1: string().when('billingIsSame', {
      is: false,
      otherwise: (schema) => schema.notRequired(),
      then: (schema) =>
        schema
          .required(
            t ? t(BILLING_ERRORS_TEXT.Line1Required) : 'Line 1 is required.'
          )
          .min(
            MIN_FIELD_LENGTH,
            t ? t(BILLING_ERRORS_TEXT.Line1Invalid) : 'Line 1 should be longer.'
          ),
    }),
    line2: string().optional(),
    postalCode: string().when('billingIsSame', {
      is: false,
      otherwise: (schema) => schema.notRequired(),
      then: (schema) =>
        schema
          .required(t ? t(BILLING_ERRORS_TEXT.ZipRequired) : 'Zip is required.')
          .min(
            MIN_ZIP_LENGTH,
            t ? t(BILLING_ERRORS_TEXT.ZipInvalid) : 'Zip code should be longer.'
          ),
    }),
    state: string().when('billingIsSame', {
      is: false,
      otherwise: (schema) => schema.notRequired(),
      then: (schema) =>
        schema
          .required(
            t ? t(BILLING_ERRORS_TEXT.StateRequired) : 'State is required.'
          )
          .min(
            MIN_FIELD_LENGTH,
            t ? t(BILLING_ERRORS_TEXT.StateInvalid) : 'State should be longer.'
          ),
    }),
    stripeElementErrors: object()
      .shape({
        CCCVC: string().length(0),
        CCExp: string().length(0),
        CCNumber: string().length(0),
      })
      .noUnknown(),
  });
};
